var render = function render(){var _vm=this,_c=_vm._self._c;return _c('address-form',{attrs:{"title":"آدرس جدید","submit-function":_vm.createAddress}})
}
var staticRenderFns = []

export { render, staticRenderFns }